module.exports = __webpack_public_path__ + "static/media/corporate-services-img31.cbbd7ec0.jpg";